export default "__VITE_ASSET__3b581830__"